import axios from "axios";

// 创建axios实例
const api = axios.create({
  // baseURL: process.env.VUE_APP_API_URL || '/api',
  baseURL: 'https://h5.maokongai.cn/v2/api/',
  // baseURL: "http://192.168.110.35:9090/api",

  // baseURL: "http://192.168.110.211:8082/api",
  // baseURL: "http://wwj-test.yilaimi.cn/api",
  // baseURL: '/api',
  // "https://maokong.rizhaotysx.cn/api/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  },
});

api.defaults.withCredentials = true;

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // config.headers["channelKey"] = "maokong";
    // config.headers["channelKey"] = "hldwc";
    // 从localStorage获取token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["accessToken"] = token;
    }
    console.log(config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    console.log("接口返回", response);
    if (response.data.code === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      window.location.href = "/login";
      return Promise.reject(error);
    }
    return response;
  },
  (error) => {
    console.log(error);
    if (error.response && error.response.status === 401) {
      // 未授权，清除token并跳转到登录页
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// 登录相关API
export const authAPI = {
  // 发送验证码
  sendVerificationCode(params) {
    return api.post("/mobile/captcha", params);
  },

  // 登录
  login(params) {
    return api.post("/login", params);
  },

  // 微信登录相关方法 - 仅保留必要的方法
  wechatCallback(code) {
    return api.post("/oauth/login", { code: code, platform: 5 });
  },
};

// 用户相关API
export const userAPI = {
  // 获取用户信息
  getUserInfo() {
    return api.get("/user/info");
  },

  // 更新用户信息
  updateUserInfo(data) {
    return api.put("/user/info", data);
  },
};

export const payAPI = {
  // 应用内购创建订单
  createOrder(params) {
    return api.post("/payment/createOrder", params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  pay(params) {
    return api.post("/payment/pay", params, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  // 支付宝充值
  aliBuy(params) {
    return api.post("/charge/ali/buy/v2", params);
  },

  // 支付结果查询
  queryPaymentResult(orderId) {
    return api.get(`/payment/query?orderId=${orderId}`);
  },
};

export default api;
